// extracted by mini-css-extract-plugin
export default {"root":"Event_root__qGhtB","selected":"Event_selected__qR7Zy","updated":"Event_updated__ss2-J","title":"Event_title__YVEF8"};